import React from 'react';

function SolIcon1() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <circle cx="8" cy="8" r="5" fill="#D4AF37" opacity="0.85" />
      <circle cx="15" cy="13" r="4" fill="#007BFF" opacity="0.7" />
      <circle cx="7" cy="15" r="3.5" fill="#2E8B57" opacity="0.7" />
    </svg>
  );
}

function SolIcon2() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <rect x="2" y="5" width="18" height="12" rx="2" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5" />
      <rect x="5" y="8" width="12" height="6" rx="1" fill="rgba(255,255,255,0.25)" />
    </svg>
  );
}

function SolIcon3() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <path d="M11 2L20 19H2Z" fill="none" stroke="#66B2FF" strokeWidth="1.5" />
      <line x1="11" y1="7" x2="11" y2="14" stroke="#66B2FF" strokeWidth="1.2" opacity="0.6" />
    </svg>
  );
}

function SolIcon4() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <circle cx="11" cy="11" r="6" fill="none" stroke="#2E8B57" strokeWidth="1.5" />
      <circle cx="11" cy="11" r="6" fill="none" stroke="#2E8B57" strokeWidth="1.5" transform="rotate(60 11 11)" />
      <circle cx="11" cy="11" r="2.5" fill="#2E8B57" />
    </svg>
  );
}

function SolIcon5() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <path d="M5 18L11 4L17 18" fill="none" stroke="#F2D98C" strokeWidth="1.5" />
      <line x1="7" y1="14" x2="15" y2="14" stroke="#F2D98C" strokeWidth="1.2" />
    </svg>
  );
}

function SolIcon6() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <path d="M11 3Q15 10 11 17Q7 10 11 3Z" fill="#2E8B57" opacity="0.8" />
      <circle cx="11" cy="11" r="2.5" fill="#D4AF37" opacity="0.9" />
    </svg>
  );
}

export default function SolutionsSection() {
  return (
    <section id="solutions">
      <div className="sol-hdr rv">
        <div>
          <div className="kicker k-gold">Our Portfolio</div>
          <h2 className="title lt">
            Engineered for every
            <br />
            <em>polymer challenge</em>
          </h2>
        </div>
        <p className="sol-hdr-sub">
          From vivid color to invisible functionality — masterbatch solutions covering every performance dimension modern
          manufacturers demand, backed by global regulatory compliance.
        </p>
      </div>
      <div className="sol-list rv">
        <div className="sol-row">
          <div className="sol-num">01</div>
          <div className="sol-name">Color Masterbatch</div>
          <p className="sol-desc">
            Custom and standard concentrates for PE, PP, PET, ABS, and engineering polymers. RAL, Pantone, and
            brand-matched. ΔE &lt; 0.5 batch-to-batch guaranteed for blown film, injection molding, BOPET, and fiber.
          </p>
          <div className="sol-ico">
            <SolIcon1 />
          </div>
        </div>
        <div className="sol-row">
          <div className="sol-num">02</div>
          <div className="sol-name">White Masterbatch</div>
          <p className="sol-desc">
            High-opacity TiO₂ concentrations 40–70% for BOPET, BOPP, PET bottles, and multilayer film. Nano-particle
            dispersion eliminates flow marks. Food-contact and medical grades available.
          </p>
          <div className="sol-ico">
            <SolIcon2 />
          </div>
        </div>
        <div className="sol-row">
          <div className="sol-num">03</div>
          <div className="sol-name">UV Stabilizer Masterbatch</div>
          <p className="sol-desc">
            Broad-spectrum UVA + UVB + UVC protection with HALS synergist packages. FDA 21 CFR and REACH compliant.
            Outdoor packaging, agricultural film, automotive exterior, and long-term UV-resistant medical applications.
          </p>
          <div className="sol-ico">
            <SolIcon3 />
          </div>
        </div>
        <div className="sol-row">
          <div className="sol-num">04</div>
          <div className="sol-name">NIR Absorber Masterbatch</div>
          <p className="sol-desc">
            LaB₆ nanoparticle and organic dye systems for solar heat management and laser sorting (700–1200 nm).
            Transparent and opaque grades for PET bottles, film, and sheet for beverage and pharmaceutical packaging.
          </p>
          <div className="sol-ico">
            <SolIcon4 />
          </div>
        </div>
        <div className="sol-row">
          <div className="sol-num">05</div>
          <div className="sol-name">Antistatic Masterbatch</div>
          <p className="sol-desc">
            Permanent and migratory antistatic achieving surface resistivity below 10⁹ Ω/sq. Electronics packaging,
            clean-room film, technical textiles, and sensitive component trays with HDPE and PET carrier systems.
          </p>
          <div className="sol-ico">
            <SolIcon5 />
          </div>
        </div>
        <div className="sol-row">
          <div className="sol-num">06</div>
          <div className="sol-name">Bio &amp; rPET Solutions</div>
          <p className="sol-desc">
            Color and additive masterbatches for recycled PET and bio-based polymers. Color integrity maintained across
            multiple mechanical recycling cycles. Compatible with EU and Asian rPET processing standards.
          </p>
          <div className="sol-ico">
            <SolIcon6 />
          </div>
        </div>
      </div>
    </section>
  );
}
